import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import { useNavigate } from 'react-router-dom'
import DocumentHeadTags from 'components/document-head-tags'
import modalStyles from 'components/utils/modalStyles'
import styles from './index.module.css'

const Demo = (): React.ReactNode => {
  const navigate = useNavigate()

  const _closeModal = () => {
    navigate('/')
  }

  return (
    <Modal onRequestClose={_closeModal} isOpen style={modalStyles}>
      <Theme>
        <a
          className={styles.demoCloseBtn}
          title="Dismiss"
          onClick={_closeModal}
        >
          &#10005;
        </a>
        <DocumentHeadTags title="Demo | DISCO" />
        <div className={styles.demoCont}>
          <div className={styles.demoVideo}>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/5KA7j21f5GY?si=TvH46ffhWmNia_HX"
              title="DISCO demo youTube video tour"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </Theme>
    </Modal>
  )
}

export default Demo
